export const INPUT_NAMES = {
  YOUR_NAME: 'yourName',
  THEIR_NAME: 'theirName',
  CONTACT: 'contact',
};
